export default "__VITE_ASSET__CiqSIHMY__"